var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 232,
    viewBox: "0 0 233 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.953125 17.2634C0.953125 7.80649 8.61948 0.140121 18.0764 0.140121H215.103C224.559 0.140121 232.226 7.80648 232.226 17.2634V214.29C232.226 223.746 224.559 231.413 215.103 231.413H18.0764C8.61949 231.413 0.953125 223.746 0.953125 214.29V17.2634ZM70.2548 154.727C64.9567 146.825 60.6785 139.758 56.5476 132.935C48.7397 120.039 41.4583 108.012 28.8112 92.8498C26.8679 90.52 29.1454 86.9692 32.0491 87.8484L83.2801 103.359C84.8439 103.833 86.499 102.968 87.0031 101.414L105.82 43.394C106.645 40.85 110.135 40.5755 111.347 42.9592L139.677 98.6449C140.431 100.126 142.246 100.713 143.724 99.9521L194.639 73.7514C197.127 72.471 199.829 74.9914 198.696 77.5499C193.725 88.7703 189.041 97.8985 184.739 106.281L184.739 106.282L184.739 106.282C176.918 121.525 170.36 134.304 165.642 152.718C165.301 154.047 164.115 155 162.743 155.016L72.776 156.055C71.7683 156.067 70.8159 155.564 70.2548 154.727ZM70.2875 164.636L164.201 163.551C176.77 163.667 178.205 182.467 167.685 184.239L69.0384 187C55.0296 186.397 54.4776 164.782 70.2875 164.636Z",
    fill: "#9BA2AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOver);
export default __webpack_public_path__ + "static/media/сover.4b9ed2235ba83829d64f41a7cf51e757.svg";
export { ForwardRef as ReactComponent };